// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Rh4Yl","navbar__img_block":"Navbar_navbar__img_block__-OAyE","active":"Navbar_active__ghrb4"};